import moment from 'moment';

export function getTurnDays(departureDate: Date | string, arrivalDate: Date | string) {
  return moment(moment(arrivalDate).utc().format('YYYY-MM-DD')).diff(
    moment(departureDate).utc().format('YYYY-MM-DD'),
    'days',
  );
}

export function getTime(date: Date | string) {
  return moment(date).utc().format('HH:mm');
}

export function getFormattedRouteType(date?: Date | string) {
  return moment(date).utc().format('ddd, D MMM YYYY');
}

export function getNumberOfNights(departureDate?: Date | string, returnDate?: Date | string) {
  const firstDate = moment(departureDate).utc();
  const secondDate = moment(returnDate).utc();
  return secondDate.diff(firstDate, 'days', false);
}

export function formatDuration(duration, unit?: moment.unitOfTime.DurationConstructor) {
  return moment.duration(duration, unit).format(
    function () {
      if ((this as any).duration.asSeconds() >= 24 * 60 * 60) return 'd[d] h[h]';
      return 'h[h] m[m]';
    },
    { trim: 'all' },
  );
}
